import { Component } from '@angular/core';

@Component({
    selector: 'app-profile-footer',
    templateUrl: './profile-footer.component.html',
    styleUrls: ['./profile-footer.component.scss'],
    standalone: false
})
export class ProfileFooterComponent {
  currentYear = new Date().getFullYear();
}
